import React, { Component } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Header from './Header'




class ENFaq extends Component {

        state={
            collapseID:'',
            addClass:'faqQuestionActive',
            removeClass:'faqQuestionPassive'
        };

        clickBTN = (collapseID,e) => {
    
            this.setState(prevState => ({
                collapseID: prevState.collapseID !== collapseID ? collapseID : ""
              }));
            console.log(collapseID);
        }
    render() {
        return (
            <div className="mainContainer">
            <Header/>
                <div className="faqContainer">
                <div className="faqHeader">
                    
                    <h1>FAQ</h1>
                </div>
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0" className={`faqQuestion ${this.state.collapseID==='0' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("0")}>
                            What is Kassa?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Kassa is a finance tracking application by which you can keep track of all your income and expenses either individually or with your friends in private chat groups. In addition, you can add money to your Kassa using the wallet feature of Kassa, and send this money to your friends <span className="highlight">7/24</span> and <span className="highlight">free of charge </span>^___^ 
                                        </p>
                                    </div>
                                    
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1" className={`faqQuestion ${this.state.collapseID==='1' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("1")}>
                        How does Kassa work?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        First, you create a chat group of your own, and invite your friends from your the contacts list of your phone. Thus, you can both chat with friends in the group and track the expenditures you make in common. Kassa does not wear you out, and tells how much one owes to whom!
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="2" className={`faqQuestion ${this.state.collapseID==='2' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("2")}>
                        Is Kassa a paid application?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Being a member of Kassa is completely free.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="3" className={`faqQuestion ${this.state.collapseID==='3' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("3")}>
                    What does creating a group in Kassa mean?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Think of it like the ordinary chat applications that you use in daily life. 
Create a chat group, invite friends from your contacts list, and nobody else other than these people will see the conversations.  Note that you can add an expenditure as an extra feature in addition to those offered by other chat applications.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="4" className={`faqQuestion ${this.state.collapseID==='4' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("4")}>
                    Where can I use Kassa?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Examples of use: <br/><br/>

<span className="quote">Create a group named "Beşiktaş Home" with your housemate and track your house expenditures.</span><br/>
<span className="quote">Create a group named "Mor Boutique" with your workmate and track your business expenditures</span><br/>
<span className="quote">Create a group named "Jazz Festival" with your friends and track your event expenditures.</span><br/>
<span className="quote">Create a group named "Black Sea Trip" with your friends and track your holiday expenditures.</span><br/><br/>

The list of options is endless... ^^

                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="5" className={`faqQuestion ${this.state.collapseID==='5' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("5")}>
                    What is the Wallet?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="5">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        The wallet that you can create in Kassa is an e-money wallet. You can add money to the wallet, and send that money <span className="highlight">7/24</span> and <span className="highlight">free of charge</span> to any of your friends who has Kassa. You can transfer this money back to your bank account and/or withdraw it from ATM whenever you like.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="6" className={`faqQuestion ${this.state.collapseID==='6' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("6")}>
                    Is Wallet a paid application?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="6">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        There is a 0.6% commission charged by the Bankalararası Kart Merkezi (BKM) for top-ups made with debit cards. This commission does not go to us, but to the bank of the card get it. <br/>You can check more information on the link; <a href="https://bkm.com.tr/faydali-bilgiler/komisyon-ve-ucretler/bankalararasi-takas-komisyonlari/" target="_blank">https://bkm.com.tr/faydali-bilgiler/komisyon-ve-ucretler/bankalararasi-takas-komisyonlari/</a>

                                        <br/><br/>In addition, all transactions such as loading money from bank accounts, sending money to other wallets, sending from your wallet to your bank, paying bills are free with Kassa Wallet.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="7" className={`faqQuestion ${this.state.collapseID==='7' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("7")}>
                    Where can I use the Wallet?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="7">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        Case 1:<br/>
You have a group with your housemates. You keep an account of the expenditures incurred for the house and at the end of the month, you owe TL 100 to a housemate. You can pay the amount you owe to your friend with a single click from your wallet opened in Kassa 7/24 and free of charge. <br/><br/>

Case 2: <br/>
You wish to send money to your friend. Login to your wallet, click "Send Money" button and select the person that you wish to send money from your contacts list, and send the money instantly. Not to mention, it is 7/24 and free of charge. ^^
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="8" className={`faqQuestion ${this.state.collapseID==='8' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("8")}>
                    How can I open a wallet?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="8">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                        After you login to Kassa, go to the "Status" screen in the submenu. You will see the "Open a Wallet" in the upper half of the screen.
                                        </p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="9" className={`faqQuestion ${this.state.collapseID==='9' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("9")}>
                        How can I add money to the wallet?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="9">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            <span className="highlight">A. Via a Money Order/EFT from your Bank: </span>You can add money to Kassa via the "Money Transfers" step by logging into the internet/mobile banking application of your Bank. <span className="quote">(The money transfer fee that you will be charged during is charged by your bank. If it was up to us, we would make it free.)</span><br/><br/>
                                            <span className="highlight">B. Via a Debit Card: </span> By defining your debit card to Kassa, you can top up your wallet with one-click. <br/><br/>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="10" className={`faqQuestion ${this.state.collapseID==='10' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("10")}>
                        Is it secure?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="10">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Kassa complies with the laws of the Republic of Turkey and the rules of the Banking Regulation and Supervision Agency (BRSA). In this framework, the infrastructure related to the wallet and e-money services is entirely supported by<span className="highlight"> QNB Finansbank</span>.All the money you add to your wallet created in Kassa is kept in a pool account with <span className="highlight">QNB Finansbank</span><br/><br/>

                                            In other words, your money is 100% secure.^^
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="11" className={`faqQuestion ${this.state.collapseID==='11' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("11")}>
                        Is Kassa a banking application?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="11">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            No. Kassa is an independent venture established with 100% domestic investment capital. It is not a venture/company owned by a bank or an institution.  

                                            However, as we had to make an agreement with a licensor for statutory compliance and security of your money, Kassa chose <span className="highlight">QNB Finansbank</span>considering its vision and technology parallel to those of ours. We receive all infrastructure services regarding the wallet services and money transfers from <span className="highlight">QNB Finansbank</span>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="12" className={`faqQuestion ${this.state.collapseID==='12' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("12")}>
                        Can every bank user use it?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="12">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            All bank users can use Kassa.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="13" className={`faqQuestion ${this.state.collapseID==='13' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("13")}>
                        How can I get back the money that I added to the wallet?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="13">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            You can transfer the money in your wallet back to your bank account and/or withdraw it in cash from the nearest <span className="highlight">QNB Finansbank</span> whenever you like. These transactions are also free of charge.<br/><br/>
                                            <span className="highlight">Note:</span> You can transfer the money in your wallet only back to your own bank account. You cannot send it to another person's account.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="14" className={`faqQuestion ${this.state.collapseID==='14' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("14")}>
                        From which ATMs can I withdraw money?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="14">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            You can withdraw your money from the nearest <span className="highlight">QNB Finansbank</span>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="15" className={`faqQuestion ${this.state.collapseID==='15' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("15")}>
                        What limits are applied to the wallet?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="15">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            For detailed information please visit our Limits page. <a href="http://www.kassa.co/limits" target="_blank">www.kassa.co/limits</a>
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="16" className={`faqQuestion ${this.state.collapseID==='16' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("16")}>
                        Can I send money to a friend who does not have Kassa?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="16">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            While sending your money in Kassa back to the bank, you can only send it to your own bank accounts "for your security". In other words, legally you do not have the option to send the money in the wallet to the bank account of another person. In this case, you can only send the money in the wallet to the Kassa account of your friend.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="17" className={`faqQuestion ${this.state.collapseID==='17' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("17")}>
                        What does the Activities screen do?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="17">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            From the Activities screen you can keep track of all financial transactions conducted within the period. You can view all your transactions if you choose the "Log" tab from the menu in the upper screen, and only the transactions conducted via the wallet if you choose the "Wallet" tab. You can arrange all the entries displayed in this screen and/or add new entries.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="18" className={`faqQuestion ${this.state.collapseID==='18' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("18")}>
                        What does the Status screen do?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="18">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            The Status screen is where you can view and manage all your financial operations. Here you can display a summary and graphic details of all transactions within your groups in Kassa, and view your payables and receivables. From this screen, you can also open a wallet or login to an existing wallet, and conduct all your wallet transactions.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="19" className={`faqQuestion ${this.state.collapseID==='19' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("19")}>
                        What does the Groups screen do?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="19">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            From the Groups screen, you can view all chat groups opened in Kassa and/or open a new chat group. With the Direct Message (DM) button located in the upper right-hand corner of this screen, you can send a private message to any of your friends.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="20" className={`faqQuestion ${this.state.collapseID==='20' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("20")}>
                        What does the Profile screen do?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="20">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            The Profile screen is the area where you can do all your settings that you need while using Kassa. Here you can set up your profile data, and determine the user settings of Kassa. This section also contains all legal, general and other notifications regarding Kassa. Again you can use the menus in this screen to access Kassa, to ask for help or to close your Kassa account.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="21" className={`faqQuestion ${this.state.collapseID==='21' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("21")}>
                        What does the Plus (+) button do?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="21">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            The Plus (+) button allows you to access several transactions faster and easily. Using this button, you can create a group, add expenditures and/or login to your wallet, and make money transfers 7/24 and free of charge to your friends.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="22" className={`faqQuestion ${this.state.collapseID==='22' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("22")}>
                        Can I keep track of regular expenditures/bills in Kassa?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="22">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Yes, it is possible. Using either the plus (+) button on the main menu, or the plus (+) button in the group, you need to open the add expenditure page with the "Add New Expenditure" option. After entering all data as in a normal expenditure, you can determine the frequency at which your expenditures will occur and on which days these will be reflected to your Kassa using the "Regular" option.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="23" className={`faqQuestion ${this.state.collapseID==='23' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("23")}>
                        Are the expenditures that I enter in Kassa always divided equally?
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="23">
                                <Card.Body>
                                    <div className="faqAnswers">
                                        <div className="answerLeft">
                                            <p>
                                            Assume you have 5 persons in your group, including you. You enter an expenditure of TL 500. In this case, Kassa will divide the expenditure by 5, and record an expenditure per person of TL 100. However, if you click the "I Paid It" button in the upper left-hand corner while entering your data in the "Add New Expenditure" screen, you can determine by yourself the details such as who has paid the expenditure, or how much one owes.
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
            </div>
        )
    }
}

export default ENFaq